import axios from 'axios';
import type { CartItem } from 'types';

const bigcommerceMergeToCard = async (newItems: CartItem[]) => {
  await Promise.all(
    newItems.map(async (item) => {
      const bodyFormData = new FormData();

      for (const option of item.variant.options) {
        bodyFormData.append(`attribute[${option.name.split(':')[1]}]`, option.value.split(':')[1].toString());
      }
      bodyFormData.append(`product_id`, item.productId.toString());
      bodyFormData.append(`qty[]`, item.qty.toString());
      bodyFormData.append(`action`, `add`);

      await axios.post(`https://${window.location.host}/remote/v1/cart/add`, bodyFormData);
    })
  );
};
export default bigcommerceMergeToCard;
